import type * as core from '../../../../../core'

export const PACKAGE = {
  contents: [
    'package:data.higherEd.spaceFull',
    'resource:solutions.apps.space.pages.recordDetails',
    'resource:solutions.apps.space.pages.recordsList',
    'resource:solutions.apps.space.pages.serviceCenters',
    'resource:solutions.apps.space.pages.organizations',
    'resource:solutions.apps.space.pages.report',
    'resource:solutions.apps.space.pages.reports',
    'resource:solutions.apps.space.pages.surveyConfiguration',
    'resource:solutions.apps.space.pages.userAccess',
    'resource:solutions.apps.space.pages.cluster',
    'resource:solutions.apps.space.pages.clusters',
    'resource:solutions.apps.space',
  ],
  description: 'Space Full',
  name: 'Space Full',
} as const satisfies core.quiver.Package
